module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "sidebar-menu"
  }, [_c('li', {
    staticClass: "header"
  }, [_vm._v("MENU")]), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/login"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-lock"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Login")])])]), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-desktop"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Painel")])])]), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/maquinas"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa ion-android-settings"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Máquinas")])])]), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/turnos"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa ion-ios-alarm"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Turnos")])])]), _vm._v(" "), _c('li', {
    staticClass: "treeview"
  }, [_vm._m(0), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [_c('li', [_c('a', [_c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/relatorios-gerais"
    }
  }, [_c('a', [_c('span', {
    staticClass: "page"
  }, [_vm._v(" Geral")])])])], 1)])]), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [_c('li', [_c('a', [_c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/relatorios-producao"
    }
  }, [_c('a', [_c('span', {
    staticClass: "page"
  }, [_vm._v(" Percentual de Operação")])])])], 1)])]), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [_c('li', [_c('a', [_c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/relatorios-producao-tag"
    }
  }, [_c('a', [_c('span', {
    staticClass: "page"
  }, [_vm._v(" Total Produzido")])])])], 1)])]), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [_c('li', [_c('a', [_c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/relatorios-producao-Desempenho"
    }
  }, [_c('a', [_c('span', {
    staticClass: "page"
  }, [_vm._v(" Desempenho")])])])], 1)])]), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [_c('li', [_c('a', [_c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/relatorios-tag"
    }
  }, [_c('a', [_c('span', {
    staticClass: "page"
  }, [_vm._v(" Por Código")])])])], 1)])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa ion-stats-bars"
  }), _vm._v(" "), _c('span', [_vm._v("Relatórios")]), _vm._v(" "), _c('span', {
    staticClass: "pull-right-container"
  }, [_c('i', {
    staticClass: "fa fa-angle-left fa-fw pull-right"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a47fca00"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/SidebarMenu.vue
// module id = 1581
// module chunks = 1